export class Usuario {
  idUsuario: number = null;
  dsNomeUsu: string = null;
  snAtivo: string = null;
  dsSenha: string = null;
  dtCriacao: Date = null;
  dtAlteracaoSenha: Date = null;

  constructor(d?) {
    if (d) {
      this.idUsuario = d.idUsuario ? d.idUsuario : null;
      this.dsNomeUsu = d.dsNomeUsu ? d.dsNomeUsu : null;
      this.snAtivo = d.snAtivo ? d.snAtivo : null;
      this.dsSenha = d.dsSenha ? d.dsSenha : null;
      this.dtCriacao = d.dtCriacao ? d.dtCriacao : null;
      this.dtAlteracaoSenha = d.dtAlteracaoSenha ? d.dtAlteracaoSenha : null;
    }
  }
}
